module.exports = {
  "zones": {
    "Atlantic/Cape_Verde": ["z", {
      "wallclock": 186112800000,
      "format": "-01",
      "abbrev": "-01",
      "offset": -3600000,
      "posix": 186120000000,
      "save": 0
    }, {
      "wallclock": -764121600000,
      "format": "-02",
      "abbrev": "-02",
      "offset": -7200000,
      "posix": -764118000000,
      "save": 0
    }, {
      "wallclock": -862617600000,
      "format": "-01",
      "abbrev": "-01",
      "offset": -7200000,
      "posix": -862610400000,
      "save": 3600000
    }, {
      "wallclock": -1830382444000,
      "format": "-02",
      "abbrev": "-02",
      "offset": -7200000,
      "posix": -1830376800000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -5644000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};